import { Flex, type FlexProps } from '@chakra-ui/react'
import type { FC } from 'react'
import { startCase } from 'lodash'
// V1 CarrierLogo - uses raw SVG imports with Chakra v2 wrapper
// Raw SVG React components don't need Chakra context
import UPSSvg from '../../../../ui/assets/carrier-logos/ups-logo.svg?react'
import USPSSvg from '../../../../ui/assets/carrier-logos/usps-logo.svg?react'
import OSMSvg from '../../../../ui/assets/carrier-logos/osm-logo.svg?react'
import FEDEXSvg from '../../../../ui/assets/carrier-logos/fedex-logo.svg?react'
import DHLSvg from '../../../../ui/assets/carrier-logos/dhl-logo.svg?react'
import CDLSvg from '../../../../ui/assets/carrier-logos/cdl-logo.svg?react'
import EPGSvg from '../../../../ui/assets/carrier-logos/epg-logo.svg?react'
import LASERSHIPSvg from '../../../../ui/assets/carrier-logos/lasership-logo.svg?react'
import UDSSvg from '../../../../ui/assets/carrier-logos/uds-logo.svg?react'
import VEHOSvg from '../../../../ui/assets/carrier-logos/veho-logo.svg?react'
import AXLEHIRESvg from '../../../../ui/assets/carrier-logos/axlehire-logo.svg?react'
import PASSPORTGLOBALSvg from '../../../../ui/assets/carrier-logos/passport-global-logo.svg?react'
import UniUniSvg from '../../../../ui/assets/carrier-logos/uniuni-logo.svg?react'
import PurolatorSvg from '../../../../ui/assets/carrier-logos/purolator-logo.svg?react'
import SFExpressSvg from '../../../../ui/assets/carrier-logos/sf-express-logo.svg?react'
import CanadaPostSvg from '../../../../ui/assets/carrier-logos/canadapost-logo.svg?react'
import WizmoSvg from '../../../../ui/assets/carrier-logos/wizmo-logo.svg?react'

interface CarrierLogoProps extends FlexProps {
  height?: number
  width?: number
  carrier: string
}

export const CarrierLogo: FC<CarrierLogoProps> = (props) => {
  const { height = 25, width = 25, carrier, ...rest } = props
  const carrierName = carrier.toUpperCase()

  if (['UPS', 'UPSDAP', 'UPSMAILINNOVATIONS', 'UPSSUREPOST'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="UPS">
        <UPSSvg height={height} width={width} />
      </Flex>
    )
  }

  if (carrierName === 'USPS') {
    return (
      <Flex alignItems="center" {...rest} title="USPS">
        <USPSSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['OSM', 'OSMWORLDWIDE'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="OSM">
        <OSMSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['FEDEX', 'FEDEXSMARTPOST'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="FEDEX">
        <FEDEXSvg height={height} width={width} />
      </Flex>
    )
  }

  if (carrierName === 'DHLEXPRESS') {
    return (
      <Flex alignItems="center" {...rest} title="DHL Express">
        <DHLSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['CDL', 'COLUMBUSLASTMILE'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="CDL">
        <CDLSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['EPG', 'RRDONNELLEY'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="EPG">
        <EPGSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['LASERSHIP'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="LaserShip">
        <LASERSHIPSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['UDS', 'UNITEDDELIVERYSERVICE'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="UDS">
        <UDSSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['VEHO'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="Veho">
        <VEHOSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['AXLEHIRE'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="Axlehire">
        <AXLEHIRESvg height={height} width={width} />
      </Flex>
    )
  }

  if (carrierName === 'PASSPORTGLOBAL') {
    return (
      <Flex alignItems="center" {...rest} title="Passport Global">
        <PASSPORTGLOBALSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['UNIUNI'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="Uniuni">
        <UniUniSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['PUROLATOR'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="Purolator">
        <PurolatorSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['SFEXPRESS'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="SF Express">
        <SFExpressSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['CANADAPOST'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="Canada Post">
        <CanadaPostSvg height={height} width={width} />
      </Flex>
    )
  }

  if (['WIZMO'].includes(carrierName)) {
    return (
      <Flex alignItems="center" {...rest} title="Wizmo">
        <WizmoSvg height={height} width={width} />
      </Flex>
    )
  }

  return <Flex {...rest}>{startCase(carrier)}</Flex>
}

export type { CarrierLogoProps }
